import { Fragment } from "react"
import {useLocation} from "react-router-dom"

export default function Join() {

    const location = useLocation()
    const inviteCode = location.pathname.split("/")[1]

    return(
        <div className="d-flex flex-column justify-content-center align-items-center" style={{height: "88vh"}}>
            {inviteCode ?
            <a className="btn btn-success" role="button" href={`tg://join?invite=${inviteCode}`} style={{maxWidth:"200px"}}>Join Channel Or Group</a>
            :
            <Fragment>
                <h1 className="text-light">Link expired</h1>
                <p className="text-light">Send us a message to report this link</p>
                <a className="btn btn-danger" role="button" href="tg://resolve?domain=crebuo" style={{maxWidth:"200px"}}>Send message</a>
            </Fragment>
            }
        </div>
    );
}